var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddUser = function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "M22.067 18.436v2.246l-.666-.383-2.272-1.314v3.369l-1.957-1.129v-3.368l-2.935-1.696v-2.245l2.935 1.696v-3.37l.191.11 1.766 1.02v3.368l.07.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "M27.451 15.744v2.245l-2.937 1.47-.189.094-2.259 1.128v-2.245l.49-.245 1.958-.977.853-.428z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "m27.45 15.744-2.084 1.042-.854.428-1.957.977-.49.245-2.867-1.655-.07-.04.021-.012 3.277-1.64 2.087-1.041z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "M24.513 10.68v3.367l-2.087 1.042-3.276 1.64-.022.01v-3.368l.493-.245 1.763-.883 1.171-.584z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "m24.513 10.68-1.958.98-1.17.584-1.764.883-.493.245-1.766-1.02-.191-.11 5.384-2.693zM16.195 24.252v3.144L.539 18.358v-3.145q0-.953.428-1.507.234-.302.552-.442a1.5 1.5 0 0 1 .584-.12q1.52.003 3.083.473.367.11.738.248 1.208.436 2.442 1.152a21.3 21.3 0 0 1 3.182 2.272 29 29 0 0 1 3.08 3.086q.233.27.433.565.418.608.706 1.311.428 1.046.428 2M12.28 11.662q0 1.854-1.15 2.51-1.15.654-2.765-.278-1.32-.764-2.332-2.234a8 8 0 0 1-.317-.493l-.113-.189q-1.151-1.982-1.15-3.833c0-1.233.382-2.073 1.15-2.51l.202-.1q1.086-.475 2.56.378c.654.38 1.252.885 1.793 1.524q.52.615.972 1.391a9 9 0 0 1 .832 1.853 6.6 6.6 0 0 1 .318 1.981"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "M17.664 8.97q.001 1.854-1.15 2.51l-.193.096-2.084 1.042-3.107 1.553q1.15-.655 1.15-2.509 0-.047-.003-.094a6.6 6.6 0 0 0-.315-1.887 9 9 0 0 0-.832-1.853 9.7 9.7 0 0 0-.972-1.392 6.9 6.9 0 0 0-1.793-1.523q-1.474-.853-2.56-.377l5.182-2.593q1.149-.655 2.763.277 1.614.933 2.765 2.916 1.15 1.983 1.15 3.834M24.513 19.46v.201l-2.957 1.478-2.428 1.214v-3.368L21.4 20.3l.665.383 2.26-1.129zM17.172 12.449v3.163l-2.935-1.696 1.118-.557z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    d: "M21.579 21.56v3.144l-5.385 2.692v-3.144q0-.954-.428-2a7 7 0 0 0-1.139-1.877 29 29 0 0 0-3.08-3.086 21.3 21.3 0 0 0-3.182-2.272 15 15 0 0 0-3.18-1.4 10.8 10.8 0 0 0-3.082-.474 1.5 1.5 0 0 0-.584.121l4.197-2.097c.102.17.207.337.317.493q1.012 1.471 2.332 2.234 1.615.932 2.765.278l3.107-1.554q.56.345 1.117.74l-1.117.558v2.245l2.935 1.696v3.369l1.957 1.128 2.428-1.215q.022.215.022.42"
  })));
};
export default SvgAddUser;